import React, { useContext, useEffect, useRef, useState } from "react";
import StateContext from "../../context/state";
import styles from "./ParticlesLayer.module.scss";
import Particles from '../../utils/particles';
const ParticlesLayer = (props) => {

  const stateApp = useContext(StateContext);
  const [partElement, setPartElement] = useState(null);
  const { type } = props;
  const { stage, transition, isMobile } = stateApp;
  const refWrap = useRef(null);
	const [currentStage, setCurrentStage] = useState(0);
	const [reverse, setReverse] = useState(false);
  useEffect(() => {
    const wrap = refWrap.current;
    let element = new Particles(wrap, type);
    setPartElement(element);
    return () => {
      wrap.innerHTML = '';
      element = null;
      setPartElement(null)
    }
  }, [type, isMobile]);
  useEffect(() => {
		let diff = currentStage > stage;
		if (!transition && diff) {
			setReverse(true);
		} else {
			setReverse(false);
		}
	}, [currentStage, stage, transition]);
	useEffect(() => {
		let diff = currentStage - stage;
		if (reverse && !transition) {
			setCurrentStage(stage);
		}
    
		if (diff < 0 || (stage >= 1 && stage < 10) || stage >= 11) {
			setCurrentStage(stage);
		}
	}, [stage, currentStage, reverse, transition]);
  
  useEffect(() => {
    if (partElement !== null) {
      if(type === 'main'){
        switch (stage) {
          case 0:
            partElement.webgl.goto(0);
            break;
          case 1:
            partElement.webgl.goto(1);
            break;
          case 2:
            partElement.webgl.goto(2);
            break;
          case 10:
            
            partElement.webgl.goto(3);
            break;
          case 15:
            
            partElement.webgl.goto(4);
            break;
          case 16:
            
            partElement.webgl.goto(5);
            break;
          case 38:
            if(!isMobile){
            partElement.webgl.goto(6);
            }
            break;
          case 42:
            if(isMobile){
            partElement.webgl.goto(6);
            }
            break;
        
          default:
            if(partElement.webgl.particles.isInit){
              partElement.webgl.hide();
            }
            break;
        }
      }
    }
  }, [isMobile, partElement, stage, type]);

  useEffect(() => {
    if (partElement !== null) {
      if(type === 'services'){
        switch (currentStage) {
          case 0:
            partElement.webgl.goto(7);
            break;
          case 2:
            partElement.webgl.goto(8);
            break;
          case 3:
            partElement.webgl.goto(9);
            break;
          case 4:
            partElement.webgl.goto(10);
            break;
          case 5:
            partElement.webgl.goto(11);
            break;
          case 8:
            partElement.webgl.goto(12);
            break;
          case 9:
            partElement.webgl.goto(10);
            break;
          case 10:
            partElement.webgl.goto(11);
            break;
          case 14:
            partElement.webgl.goto(11);
            break;
          case 15:
            partElement.webgl.goto(11);
            break;
          default:
            if(partElement.webgl.particles.isInit){
              partElement.webgl.hide();
            }
            break;
        }
      }
    }
  }, [partElement, currentStage, type]);

  useEffect(() => {
    if (partElement !== null) {
      if(type === 'compare'){
        switch (currentStage) {
          case 5:
            partElement.webgl.goto(13);
            break;
          case 6:
            partElement.webgl.goto(14);
            break;
          default:
            if(partElement.webgl.particles.isInit){
              partElement.webgl.hide();
            }
            break;
        }
      }
    }
  }, [partElement, currentStage, type]); 
  return (
    <>
      <div className={styles.wrap} ref={refWrap}>

      </div>
    </>
  );

}

export default ParticlesLayer;
